export default "__VITE_ASSET__BGnpZBny__"